import { debounceTime, fromEvent } from 'rxjs';
import ModalStep from '../enums/modalStep';

export default class DateInput {
  dateInputSubscription = null;

  constructor(rootComponent, date, dateChangeCallback) {
    this.rootComponent = rootComponent;
    this.dateChangeCallback = dateChangeCallback;
    this.id = 'dateInput';
    this.date = date;
    this.selector = '[data-self-guided-date-input]';
    this.rootComponent.subscribe('domUpdate', this.onDomUpdate.bind(this));
    this.isDisabled = this.rootComponent.unavailableTours;
  }

  static formatUTCForLocalInput(date) {
    // Get local year, month, and day
    const year = date.getFullYear(); // Local year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Local month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, '0'); // Local day

    // Format as 'YYYY-MM-DD for the input type="date" value'
    return `${year}-${month}-${day}`;
  }

  onDomUpdate(event) {
    if (event.detail && event.detail.step === ModalStep.DateTimeSelection) {
      const dateInput = this.getDateInput();
      this.dateInputSubscription = fromEvent(dateInput, 'change')
        .pipe(debounceTime(350))
        .subscribe((e) => {
          this.dateChangeCallback(new Date(e.target.value));
        });
    } else if (this.dateInputSubscription) {
      this.dateInputSubscription.unsubscribe();
      this.dateInputSubscription = null;
    }
  }

  getDateInput() {
    return document.querySelector(this.selector);
  }

  render() {
    // Get the current date or use the provided date
    const date = this.date || new Date();
    return `
        <div class="nhs-c-input__wrapper">
            <label class="nhs-c-input__label nhs-o-typography--sans-body-1-small-regular" for="date">Tour date</label>
            <input min="${DateInput.formatUTCForLocalInput(date)}" type="date" 
            id="${this.id}" name="date" class="nhs-c-input__date nhs-u-width--full" 
            data-self-guided-date-input value="${DateInput.formatUTCForLocalInput(date)}"
            ${this.isDisabled ? 'disabled' : ''}>
        </div>`;
  }

  update(newDate) {
    const dateInput = this.getDateInput();
    if (!dateInput) {
      return;
    }
    dateInput.value = DateInput.formatUTCForLocalInput(newDate);
    this.date = newDate;
  }
}
